import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Header from "./Header";
import "./CompanyPages.css";

const services = [
  {
    number: "01",
    label: "AIで作ったツールを、使い続けるために",
    title: "つくったあと",
    description: "AIで作った社内ツールの改修・運用を支援します。利用権限、データの保存先、利用費用、更新や引き継ぎの方法を整理し、日々の業務で使える状態に整えます。",
    items: ["社内ツールの不具合・機能改修", "利用権限・保存先・費用の確認", "更新・運用・引き継ぎの整理"],
    to: "/shikumi-seibi",
    link: "「つくったあと」を詳しく見る",
  },
  {
    number: "02",
    label: "仕事の流れに合わせて、仕組みをつくる",
    title: "業務システム・クラウド開発",
    description: "現在の業務や使っているシステムを確認し、仕事の流れに合うシステムを開発します。クラウドへの移行から、導入後の運用までご相談いただけます。",
    items: ["業務に合わせたシステム開発", "クラウドへの移行・構築", "導入後の運用支援"],
    to: "/dx",
    link: "開発・クラウド支援を詳しく見る",
  },
  {
    number: "03",
    label: "いつものサービスを、会話から使えるように",
    title: "ChatGPTアプリ連携",
    description: "Apps SDKとMCPを使い、既存サービスの検索や操作をChatGPTから使える形にします。連携したい機能やデータを確認し、会話から利用するためのアプリを開発します。",
    items: ["ChatGPTからの検索・操作", "Apps SDKを使ったアプリ開発", "MCPサーバーの構築・連携"],
    to: "/apps-sdk",
    link: "ChatGPTアプリ連携を詳しく見る",
  },
];

const Service = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="home">
      <Header />
      <main className="wc-info" id="first">
        <div className="wc-info-container">
          <div className="wc-info-intro">
            <p className="wc-info-eyebrow">SERVICES</p>
            <h1>サービス</h1>
            <p className="wc-info-lead">新しくつくることも、いまあるものを使い続けることも。<br className="wc-info-desktop-break" />業務とツールの状況に合わせて、開発・改修・運用を支援します。</p>
          </div>
          <div className="wc-info-services">
            {services.map((service) => (
              <section className="wc-info-service" key={service.to}>
                <span className="wc-info-number" aria-hidden="true">{service.number}</span>
                <div className="wc-info-service-body">
                  <p className="wc-info-label">{service.label}</p>
                  <h2>{service.title}</h2>
                  <p className="wc-info-description">{service.description}</p>
                  <ul className="wc-info-tags">
                    {service.items.map((item) => <li key={item}>{item}</li>)}
                  </ul>
                  <Link className="wc-info-link" to={service.to}>{service.link}<span aria-hidden="true">↗</span></Link>
                </div>
              </section>
            ))}
          </div>
          <aside className="wc-info-contact">
            <div><h2>相談先に迷ったら</h2><p>困っていることや、実現したいことからお聞かせください。</p></div>
            <Link className="wc-info-button" to="/contact">お問い合わせ<span aria-hidden="true">→</span></Link>
          </aside>
        </div>
      </main>
    </div>
  );
};

export default Service;
